import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import PageLayout from '@BUP/components/Layout/Page'
import { CurrentTermContext } from '@BUP/contexts/CurrentTermContext'
import { EventsContextProvider } from '@BUP/contexts/EventsContext'
import HistoricSociogramContent from './historic-sociogram-content'
import { ResultsGroupedByYearContextProvider } from '@BUP/contexts/ResultsGroupedByYearContext'
import { OrganizationContext } from '@BUP/contexts/OrganizationContext'

const HistoricSociogramPage = () => {
  const i18n = useTranslation()
  const term = useContext(CurrentTermContext)
  const organization = useContext(OrganizationContext)
  const { id: organizationId } = organization

  return (
    <PageLayout pageName={i18n.t('pages.data.historicalSociogram.title')}>
      <EventsContextProvider termId={term.id}>
        <ResultsGroupedByYearContextProvider organizationId={organizationId}>
          <HistoricSociogramContent />
        </ResultsGroupedByYearContextProvider>
      </EventsContextProvider>
    </PageLayout>
  )
}

export default HistoricSociogramPage
